import { render } from "./AssTeacherHome.vue?vue&type=template&id=76531430&scoped=true"
import script from "./AssTeacherHome.vue?vue&type=script&lang=js"
export * from "./AssTeacherHome.vue?vue&type=script&lang=js"

import "./AssTeacherHome.vue?vue&type=style&index=0&id=76531430&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukataa APP-Admin\\Edukatta_UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76531430"]])

export default __exports__